export default __webpack_public_path__ + "static/media/background.eeb8db5e.jpg";